<div class="e-top-bar-container">
    <button class="e-back-button" (click)="backClicked()">
        <i class="fas fa-arrow-left"></i>
        Back
    </button>
    <div class="e-search-bar-container">
        <via-search-bar></via-search-bar>
    </div>
    <!-- TODO
    <button class="e-sets-button">
        <i class="far fa-clone"></i>
        Sets
    </button>
    -->
</div>
